<script setup>
import { computed, onMounted } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  inboxStatus: {
    type: Object,
    default: () => ({}),
  },
});

const reauthorizationRequired = computed(() => props.inbox.reauthorization_required);
const isConnected = computed(() => props.inboxStatus?.connected === true);
const hasAI = computed(() => props.inboxStatus?.hasAI === true);

// Debug - remover depois
onMounted(() => {
  if (Object.keys(props.inboxStatus).length > 0) {
    console.log('ChannelLeaf:', props.inbox.name, 'status:', props.inboxStatus);
  }
});

const iconWrapperClasses = computed(() => {
  if (isConnected.value && hasAI.value) {
    return 'inbox-connected-ai';
  } else if (isConnected.value) {
    return 'inbox-connected';
  }
  return '';
});
</script>

<template>
  <span
    class="size-4 grid place-content-center rounded-full bg-n-alpha-2 relative overflow-hidden"
    :class="[{ 'bg-n-solid-blue': active }, iconWrapperClasses]"
  >
    <!-- Efeito shimmer para IA conectada -->
    <span
      v-if="isConnected && hasAI"
      class="absolute inset-0 shimmer-effect"
    />
    <ChannelIcon :inbox="inbox" class="size-3 relative z-10" />
  </span>
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>

<style scoped>
/* Inbox conectada - gradiente azul */
.inbox-connected {
  background: linear-gradient(135deg, #6366f1, #818cf8) !important;
  box-shadow: 0 0 8px rgba(99, 102, 241, 0.5);
}

/* Inbox conectada com IA - gradiente roxo/azul vibrante */
.inbox-connected-ai {
  background: linear-gradient(135deg, #8b5cf6, #6366f1, #3b82f6) !important;
  animation: pulse-glow 2s ease-in-out infinite;
}

/* Efeito de brilho passando */
.shimmer-effect {
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.5) 50%,
    transparent 100%
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Animação de pulso com glow */
@keyframes pulse-glow {
  0%,
  100% {
    box-shadow:
      0 0 8px rgba(139, 92, 246, 0.6),
      0 0 15px rgba(99, 102, 241, 0.4);
  }
  50% {
    box-shadow:
      0 0 20px rgba(139, 92, 246, 0.9),
      0 0 35px rgba(99, 102, 241, 0.6);
  }
}
</style>
